import { motion } from 'framer-motion'
import { cn } from '../../utils/cn'

export default function Editorial() {
  return (
    <section id="about" className="py-20 lg:py-32 bg-bg-primary">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image - Left Side */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative aspect-[4/5] bg-bg-tertiary overflow-hidden"
          >
            <img
              src="/images/editorial-1.png"
              alt="Fashion editorial with elegant nails"
              className="absolute inset-0 w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
            {/* Fallback */}
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-text-muted text-sm">Editorial Image</span>
            </div>
          </motion.div>

          {/* Content - Right Side */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:pl-8"
          >
            {/* Eyebrow */}
            <p className="text-xs uppercase tracking-[0.3em] text-text-muted mb-4">
              The Nakhoons Story
            </p>

            {/* Headline */}
            <h2 className="text-display-md font-serif font-medium text-text-primary mb-6">
              Where Fashion<br />
              Meets <span className="italic">Innovation</span>
            </h2>

            {/* Description */}
            <div className="space-y-4 text-base text-text-secondary mb-10">
              <p>
                Born from a passion for beauty and technology, Nakhoons represents
                the future of self-expression. Our smart press-on nails combine
                luxury craftsmanship with cutting-edge NFC technology.
              </p>
              <p>
                Each set is carefully designed to not only look stunning but to
                seamlessly integrate with your digital life. From contactless
                payments to instant information sharing, your nails become an
                extension of your connected world.
              </p>
            </div>

            {/* Quote */}
            <blockquote className="border-l-2 border-primary pl-6 py-2 mb-10">
              <p className="text-lg font-serif italic text-text-primary">
                "Beauty is not just about how you look, but how you connect."
              </p>
              <cite className="text-sm text-text-muted mt-2 block not-italic">
                — Founder, Nakhoons
              </cite>
            </blockquote>

            {/* CTA */}
            <a
              href="#contact"
              className={cn(
                'inline-flex items-center gap-2',
                'text-sm font-medium text-primary uppercase tracking-wider',
                'border-b border-primary pb-1',
                'hover:opacity-70 transition-opacity duration-300'
              )}
            >
              Read More
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
